import { getI18n } from 'react-i18next';

export const RESET_PASSWORD_TOKEN_INVALID = 'validation.tokenAlreadyUsed';
export const INVALID_PASSWORD_RESET_REQUEST = 'validation.resetPassword.requestInvalid';

export const createPasswordResetTokenInvalidMessage = (code) => {
    switch (code) {
        case RESET_PASSWORD_TOKEN_INVALID:
            return getI18n().t('reset-password.errors.invalid-token');
        case INVALID_PASSWORD_RESET_REQUEST:
            return getI18n().t('reset-password.errors.requestInvalid');
        default:
            return undefined;
    }
};
